export const ALERTS_SEARCH_LIMIT = 250;

export const SUBSCRIPTIONS_SEARCH_LIMIT = 150;
